module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-meet/bg.png",
      "swiper": _vm.swiper,
      "hasDownBtn": true
    }
  }, [(_vm.dataInfo) ? _c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    Hi，"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.customerName))]), _vm._v("老师"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.dataInfo.registrationDate))]), _vm._v("，您第一次与吉凯相遇"), _c('br'), _vm._v("\n    我们共同走过了"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.dataInfo.registrationDatetoToday))]), _c('br'), _vm._v(" "), (_vm.dataInfo.registrationDateYear > 0) ? _c('span', [_vm._v("科研路漫漫，过程中体会到了坚持的力量"), _c('br'), _vm._v("不忘初心，我们继续携手探索科研的奥秘")]) : _c('span', [_vm._v("希望我们来日方长"), _c('br'), _vm._v("我们携手并进，继续创造无限可能")])]) : _c('div', {
    staticClass: "main-text ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn"
    }
  }, [_vm._v("\n    Hi，"), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.customerName))]), _vm._v("老师"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-highline"
  }, [_vm._v(_vm._s(_vm.customerCreateDT))]), _vm._v("今天是您第一次与吉凯相遇"), _c('br'), _vm._v("\n    终于等到您了~"), _c('br'), _vm._v("\n    未来日子里吉凯陪您「研途可期」\n  ")]), _vm._v(" "), _c('img', {
    staticClass: "main-image ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/shape01.png"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-408f0bab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageMeet/index.vue
// module id = 1614
// module chunks = 8